import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DateTimeService } from '@valg-shared/services/date-time-service/date-time.service';
import { CandidateDataLoadState, ResultSummaryDto, ResultType } from "@shared/clients/api.generated";
import { EnumService } from "@valg-shared/services/enums/enum.service";


export interface CountStatus {
  id?: string;
  name: string;
  percentage?: number;
}


@Component({
  selector: 'valg-dk-count-status',
  templateUrl: './count-status.component.html',
  styleUrls: [ './count-status.component.scss' ]
})

export class CountStatusComponent implements OnChanges{
  @Input() title!: string;
  @Input() data: CountStatus[] = [];
  @Input() updated?: Date;
  @Input() resultType?: ResultType;
  @Input() candidateDataLoadState?: CandidateDataLoadState;
  @Input() isNavigation = false;
  @Input() prefixUrl?: string;
  updatedTime = "";
  displayResultType?: string;
  addSuffix = false;
  @Input() resultSummary?: ResultSummaryDto;
 
  constructor(
    private readonly dateTimeService: DateTimeService,
    private readonly enumService: EnumService){
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.['updated']?.currentValue){
      this.updatedTime = this.dateTimeService.datePipeTransformDateTimeWithoutSecond(this.updated!) ?? "";
      if (this.resultType === ResultType.PreliminaryResult || this.resultType === ResultType.FinalResult) {
        this.displayResultType = `${this.enumService.translateValue(this.resultType, 'ResultType')}`
        this.addSuffix = this.title == "count_status.title" ? true : false;
      }
    }
  }

  get hasRegisteredResults() {
    if (this.candidateDataLoadState == CandidateDataLoadState.NotLoaded) {
      return false;
    }
    if (this.data == null || this.data.length == 0) {
      return false;
    }
    return this.data.some(cs => cs.percentage !== null && cs.percentage! > 0);
  }
}
